import { useQuery } from '@tanstack/react-query';
import Api, { withAcl } from 'hooks/Api';
import { useAdmin, useAdminParams } from 'utils/helpers';
import { useProvider } from 'utils/providers/Provider';
import { Plan } from 'utils/types';

import c from '../utils/constants';

export default function useGetPlan(options = {}) {
  const { state } = useProvider();
  const { accountId } = useAdminParams();
  const { isAdmin } = useAdmin();
  const args = state;

  return useQuery<Plan>({
    queryKey: [c.PLAN],
    queryFn: async () => {
      if (!isAdmin && !state.isEmailAddressVerified) return null;

      const api = new Api(args);

      const data = await api.get(
        await withAcl({
          account: {
            url: 'api/v1/plans',
          },
          admin: {
            url: `api/v2/accounts/${accountId}/plans`,
          },
        }),
      );

      return data?.data;
    },
    enabled: state.isAuthenticated,
    ...options,
  });
}
